import {SimplePageLayout} from '@flexinet/ui-components';


export const GeneralPage = () => {

    return (
        <SimplePageLayout
            pageHeader={<div/>}
            pageNavigation={<div/>}
        >
            General Settings
        </SimplePageLayout>
    );
};
